'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var HEY_LISTEN = 'Hey, listen! ';
exports.warning = function () { };
exports.invariant = function () { };
if (process.env.NODE_ENV !== 'production') {
    exports.warning = function (check, message) {
        if (!check && typeof console !== 'undefined') {
            console.warn(HEY_LISTEN + message);
        }
    };
    exports.invariant = function (check, message) {
        if (!check) {
            throw new Error(HEY_LISTEN.toUpperCase() + message);
        }
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/hey-listen/lib/index.js
// module id = 5
// module chunks = 35783957827783 107818501498521 212839066777427